import { useState, useEffect } from 'react'
import { useSession, signIn } from 'next-auth/client'
import { getUserOfferRequests } from 'lib/services/offer-requests/get-offers'
import { isGuestAccount } from 'lib/utils/login'
import LoadingSpinner from 'components/LoadingSpinner'
import GuestPrompt from './GuestPrompt'
import OfferList from './OfferList'
import styles from './MyAccount.module.scss'

export default function MyAccount() {
  const [loadingOffers, setIsLoadingOffers] = useState(false)
  const [offers, setOffers] = useState(null)
  const [session, loading] = useSession()
  const isGuest = isGuestAccount(session)

  const isLogged = loading === false && session !== null

  const getUserOffers = async () => {
    setIsLoadingOffers(true)
    const { email } = session.user
    const result = await getUserOfferRequests(email)

    setOffers(result)
    setIsLoadingOffers(false)
  }

  /**
   * Trigger user offer fetch
   * when logged in
   */
  useEffect(() => {
    if (isLogged) {
      getUserOffers()
    }
  }, [isLogged])

  return (
    <section>
      <div className="container">
        {!isLogged && (
          <button className="btn btn--primary" onClick={() => signIn()}>
            Jatka kirjautumalla sisään
          </button>
        )}

        {isGuest && <GuestPrompt />}

        {isLogged && !isGuest && (
          <>
            <h2 className={`gradient-text ${styles.title}`}>
              Minun tarjouspyyntöni
            </h2>
            <OfferList offers={offers} />
          </>
        )}

        {(loading || loadingOffers) && (
          <div className="text-center">
            <LoadingSpinner />
          </div>
        )}
      </div>
    </section>
  )
}
